import { type Context, createContext } from 'react';

import type { RadioGroupState, ToggleButtonGroupProps } from '../types.js';

/** @internal */
export type ButtonGroupContextType = {
  state?: RadioGroupState & Pick<ToggleButtonGroupProps, 'onChange'>;
};

/**
 * Context to hold the state of the button group
 * @internal
 */
export const ButtonGroupContext: Context<ButtonGroupContextType> =
  createContext<ButtonGroupContextType>({});
